import { SET_USERS, SET_USERS_UPDATED } from '../constants/UserConstants';

const initialState = {
  users: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USERS: {
      return {
        ...state,
        users: action.payload,
        updated: false,
      };
    }

    case SET_USERS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default:
      return state;
  }
}
